var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('map-loader',{attrs:{"map-config":_vm.mapConfig}},[_vm._l((_vm.markers),function(marker,index){return [_c('map-marker',{key:index,attrs:{"position":marker}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }